// Material Kit 2 React pages
import VentureList from "presentation/components/VentureListPage";

export default function VentureListPage() {
  return <VentureList />;
}
